module.exports = __webpack_public_path__ + "Roboto-Light.3c37aa69cd77e6a53a06.woff2";


//////////////////
// WEBPACK FOOTER
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/node_modules/materialize-css/dist/fonts/roboto/Roboto-Light.woff2
// module id = ../../../../materialize-css/dist/fonts/roboto/Roboto-Light.woff2
// module chunks = vendor